var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHintHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 18.125h6.25M6.149 13.047A6.211 6.211 0 0 1 3.75 8.164c-.016-3.39 2.711-6.211 6.102-6.29a6.25 6.25 0 0 1 4.007 11.165 1.89 1.89 0 0 0-.734 1.492V15a.625.625 0 0 1-.625.625h-5A.625.625 0 0 1 6.875 15v-.469a1.907 1.907 0 0 0-.726-1.484v0Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.633 4.438a3.742 3.742 0 0 1 3.062 3.054",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHintHelp);
export default __webpack_public_path__ + "static/media/icon_hint_help.a6171cacd0642598e76ed4fbf8908183.svg";
export { ForwardRef as ReactComponent };